export class UpdateWorkspaceStorageAccessConfigurationInputGcp {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "allowedPrincipals",
            "baseName": "allowedPrincipals",
            "type": "Array<WorkspaceAllowedPrincipalInput>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateWorkspaceStorageAccessConfigurationInputGcp.attributeTypeMap;
    }
    constructor() {
    }
}
